import React,{useState,useEffect} from 'react'



import { Switch } from '@mui/material';

import AppLayout from '../../../../layout/components/AppLayout';
import CMSPagesForm from '../components/CMSPagesForm';
import cmsPagesServices from '../cmsPagesServices';


function ManageCMSPagesPage() {
  const [pageList,setPageList] = useState(null);
  const getPageList = () =>{
    cmsPagesServices.getList().then(res=>{
      setPageList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }
  useEffect(()=>{
    getPageList()
  },[])

  const handleStatusChange = (e,id) =>{
    let payload = {
      id:id,
      status:e.target.checked ? 1 : 0,
    }
    console.log(payload);
    cmsPagesServices.save(payload).then(res=>{
      getPageList();
    })
  }

  return (
    <AppLayout>
      <div className="container">
      <div className='row'>
        <div className='col-md-9'>
          <h3>Pages List</h3>
        </div>
        <div className='col-md-3'>
        <span className='float-end'><CMSPagesForm refreshList={getPageList} /></span>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <table className='table'>
            <thead>
              <tr>
                <td>Page</td>
                <td>Page Title</td>
              </tr>
            </thead>
            <tbody>
              {pageList && pageList.map(page=>
                <tr key={page.id}>
                  <td>{ page.slug}</td>
                  <td>{page.title}</td>
                  <td>
                    <div>
                      <CMSPagesForm refreshList={getPageList} data={page} />
                      <Switch 
                        color="success"
                        checked={page.status === 1}
                        onChange={(e)=>handleStatusChange(e,page.id)}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      </div>
    </AppLayout>
  )
}

export default ManageCMSPagesPage